module.exports = __webpack_public_path__ + "img/time_reduction.969a3b37.svg";